import { render, staticRenderFns } from "./AdvancedSlotAdding.vue?vue&type=template&id=0a1fb136&scoped=true"
import script from "./AdvancedSlotAdding.vue?vue&type=script&lang=js"
export * from "./AdvancedSlotAdding.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSlotAdding.vue?vue&type=style&index=0&id=0a1fb136&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1fb136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1fb136')) {
      api.createRecord('0a1fb136', component.options)
    } else {
      api.reload('0a1fb136', component.options)
    }
    module.hot.accept("./AdvancedSlotAdding.vue?vue&type=template&id=0a1fb136&scoped=true", function () {
      api.rerender('0a1fb136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/modals/AdvancedSlotAdding.vue"
export default component.exports